import { computed, type MaybeRefOrGetter, toValue } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { settingsDataSource } from "@/di/datasources";

export type SettingsKey = "terms-of-use" | "privacy-policy";

export const SETTINGS_TITLES: Record<SettingsKey, string> = {
  "terms-of-use": "Termos de uso",
  "privacy-policy": "Politica de privacidade",
};

/** Mesma regra do `getSettings` legado: o texto pode vir em `data.terms_of_use` ou direto em `data`. */
export const settingsText = (res: any): string => res?.data?.terms_of_use || res?.data || "";

/** Texto de termos de uso / política de privacidade (HTML vindo da API). */
export function useSettingsText(key: MaybeRefOrGetter<SettingsKey | "">) {
  return useQuery({
    queryKey: computed(() => ["settings", toValue(key)]),
    enabled: computed(() => !!toValue(key)),
    queryFn: async () => {
      const k = toValue(key);
      const res = k === "privacy-policy" ? await settingsDataSource.getPrivacyPolicy() : await settingsDataSource.getTermsOfUse();
      return settingsText(res);
    },
  });
}
